import { render, staticRenderFns } from "./MaterialAction.vue?vue&type=template&id=6b158f96"
import script from "./MaterialAction.vue?vue&type=script&lang=js"
export * from "./MaterialAction.vue?vue&type=script&lang=js"
import style0 from "./MaterialAction.vue?vue&type=style&index=0&id=6b158f96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports